import {
  useSelector,
  useDispatch,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
  ResourceType,
} from '@gymcloud/core';

export const useEntityState = (id: number, resourceType: ResourceType) => {
  const programSelector = coreSelectors.getResourceById(
    resourceType,
    id,
  );
  return {
    user: useSelector(programSelector), // TODO
  };
};

export const useEntityDispatch = ({
  id,
  resourceType,
}: {
  id: number,
  resourceType: ResourceType,
}) => {
  const dispatch = useDispatch();

  const updateEntity = (payload: any) => {
    dispatch(
      coreActions.updateResources({
        resources: [{ id, ...payload }],
        resourceType,
      }),
    );

    dispatch(
      coreActions.requestUpdateEntity({
        id,
        payload,
        resourceType,
      }),
    );
  };

  return {
    updateEntity,
  };
};
